"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementPosition = void 0;
var _esToolkit = require("es-toolkit");
var _react = require("react");
const useElementPosition = (delay = 250) => {
  const ref = (0, _react.useRef)(null);
  const cachedSnapshot = (0, _react.useRef)({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
    distanceFromLeft: 0,
    distanceFromRight: 0
  });
  const subscribe = (0, _react.useCallback)(callback => {
    const debouncedListener = (0, _esToolkit.debounce)(callback, delay);
    window.addEventListener('resize', debouncedListener);
    window.addEventListener('scroll', debouncedListener);
    return () => {
      window.removeEventListener('resize', debouncedListener);
      window.removeEventListener('scroll', debouncedListener);
    };
  }, [delay]);
  const getSnapshot = (0, _react.useCallback)(() => {
    if (!ref.current) {
      return cachedSnapshot.current;
    }
    const rect = ref.current.getBoundingClientRect();
    const distanceFromRight = window.innerWidth - rect.right;
    const distanceFromLeft = rect.left;
    const newSnapshot = {
      left: rect.left,
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.width,
      height: rect.height,
      distanceFromLeft,
      distanceFromRight
    };
    if ((0, _esToolkit.isEqual)(newSnapshot, cachedSnapshot.current)) {
      return cachedSnapshot.current;
    }
    cachedSnapshot.current = newSnapshot;
    return cachedSnapshot.current;
  }, []);
  const getServerSnapshot = (0, _react.useCallback)(() => cachedSnapshot.current, []);
  const position = (0, _react.useSyncExternalStore)(subscribe, getSnapshot, getServerSnapshot);
  return [ref, position];
};
exports.useElementPosition = useElementPosition;
